module.exports = __webpack_public_path__ + "static/media/features-split-image-01.76803509.png";